/**
 * Notification recipients & contact details.
 *
 * TODO (Nick/Winnie): replace the placeholder recipients below with the real
 * addresses before production. Per framework Part D, the 2nd payment approver is
 * Shijie Dong (Tuo as backup) — set secondApproverEmail accordingly. financeEmail
 * receives AR / finance notices. companyPhone appears in buyer-facing emails.
 *
 * These default to developer@directauto.net.au (the project's working inbox) so
 * notifications deliver; they are safe to change without any other code changes.
 */
export const NOTIFICATIONS = {
  secondApproverEmail: 'developer@directauto.net.au', // TODO: Shijie Dong (or Tuo) — 2nd payment approver
  financeEmail: 'developer@directauto.net.au',        // TODO: Direct Auto finance inbox (AR notices)
  companyPhone: '(03) 0000 0000',                     // TODO: real Direct Auto phone number
};
